import React from 'react';
import Badge from '@atlaskit/badge';
import { Text } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
export var ToolbarKeyboardShortcutHint = function ToolbarKeyboardShortcutHint(_ref) {
  var shortcut = _ref.shortcut,
    isDisabled = _ref.isDisabled;
  if (isDisabled && expValEquals('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true)) {
    return /*#__PURE__*/React.createElement(Badge, {
      appearance: "primaryInverted"
    }, /*#__PURE__*/React.createElement(Text, {
      color: "color.text.disabled"
    }, shortcut));
  }
  return /*#__PURE__*/React.createElement(Badge, null, shortcut);
};